export enum FcdParameterType {
  V = 'V',
  VFREE = 'VFREE',
  LOS = 'LOS',
  TIMELOSS = 'TIMELOSS',
  TRAVELTIMESELF = 'TRAVELTIMESELF',
  CONFIDENCE = 'CONFIDENCE',
}
